import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  unfilled: PropTypes.bool
};
const Range = createComponent({
  displayName: 'Range',
  root: 'input',
  propTypes,
  propConfig: {
    classNames(props) {
      const {
        unfilled = false
      } = props;
      const classesSet = new Set(['swan-range']);
      if (unfilled) classesSet.add('swan-range-unfilled');
      return classesSet;
    }
  }
});
Range.defaultProps = {
  type: 'range'
};
export { Range };